/**
 * Funções Utilitárias para o Modal de Exercícios
 *
 * Responsabilidade:
 * - Validar arquivos (imagem e vídeo) quanto ao tamanho.
 * - Ler arquivos e converter para Base64.
 * - Manter funções puras que não dependem do estado do componente.
 */

import { toast } from "react-toastify";

export const validateImage = (file: File): boolean => {
  const maxSize = 5 * 1024 * 1024; // 5MB
  if (file.size > maxSize) {
    toast.error("A imagem deve ter no máximo 5MB");
    return false;
  }
  return true;
};

export const validateVideo = (file: File): boolean => {
  const allowed = [".mp4", ".mov", ".m4v", ".3gp"];
  const lower = file.name.toLowerCase();
  const okExt = allowed.some((ext) => lower.endsWith(ext));
  const okMime =
    file.type.startsWith("video/") || file.type === "application/octet-stream";
  if (!okExt || !okMime) {
    toast.error(`Formato não suportado. Use: ${allowed.join(", ")}`);
    return false;
  }
  const maxSize = 1024 * 1024 * 1024; // 1GB (multipart)
  if (file.size > maxSize) {
    toast.error("O vídeo deve ter no máximo 1GB");
    return false;
  }
  return true;
};

export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
